import { render, staticRenderFns } from "./VipList.vue?vue&type=template&id=eec5d72a&scoped=true&"
import script from "./VipList.vue?vue&type=script&lang=js&"
export * from "./VipList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eec5d72a",
  null
  
)

export default component.exports